import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
  type EnumeratedLiteralModel,
} from "./enumeratedLiterals";

export const Regions = enumeratedLiterals(
  ["EUROPE", "FAR_EAST", "NORTH_AMERICA"] as const,
  {
    getAttributes: (a) =>
      ({
        [a.EUROPE]: {
          abbreviatedLabel: "eu",
          amazonSellerName: "Amazon Seller - Europe",
          amazonSecretName: "amazon-seller-secret-eu",
        },
        [a.FAR_EAST]: {
          abbreviatedLabel: "fe",
          amazonSellerName: "Amazon Seller - Far East",
          amazonSecretName: "amazon-seller-secret-fe",
        },
        [a.NORTH_AMERICA]: {
          abbreviatedLabel: "na",
          amazonSellerName: "Amazon Seller - North America",
          amazonSecretName: "amazon-seller-secret",
        },
      } as const),
  },
);

export type RegionCode = EnumeratedLiteralType<typeof Regions>;
export type Region = EnumeratedLiteralModel<typeof Regions>;

export const CountryCodes = enumeratedLiterals(
  [
    "US",
    "CA",
    "BR",
    "MX",
    "JP",
    "AU",
    "SG",
    "GB",
    "ES",
    "FR",
    "NL",
    "DE",
    "IT",
    "SE",
    "PL",
    "BE",
    "EG",
    "TR",
    "SA",
    "AE",
    "IN",
  ] as const,
  {
    getAttributes: (a) =>
      ({
        [a.US]: { region: Regions.NORTH_AMERICA }, // United States
        [a.CA]: { region: Regions.NORTH_AMERICA }, // Canada
        [a.BR]: { region: Regions.NORTH_AMERICA }, // Brazil
        [a.MX]: { region: Regions.NORTH_AMERICA }, // Mexico
        [a.JP]: { region: Regions.FAR_EAST }, // Japan
        [a.AU]: { region: Regions.FAR_EAST }, // Australia
        [a.SG]: { region: Regions.FAR_EAST }, // Singapore
        [a.GB]: { region: Regions.EUROPE }, // UK
        [a.ES]: { region: Regions.EUROPE }, // Spain
        [a.FR]: { region: Regions.EUROPE }, // France
        [a.NL]: { region: Regions.EUROPE }, // Netherland
        [a.DE]: { region: Regions.EUROPE }, // Germany
        [a.IT]: { region: Regions.EUROPE }, // Italy
        [a.SE]: { region: Regions.EUROPE }, // Sweden
        [a.PL]: { region: Regions.EUROPE }, // Poland
        [a.BE]: { region: Regions.EUROPE }, // Belgium
        [a.EG]: { region: Regions.EUROPE }, // Egypt
        [a.TR]: { region: Regions.EUROPE }, // Turkey
        [a.SA]: { region: Regions.EUROPE }, // Saudi Arabia
        [a.AE]: { region: Regions.EUROPE }, // U.A.E.
        [a.IN]: { region: Regions.EUROPE }, // India
      } as const),
  },
);

export type CountryCode = EnumeratedLiteralType<typeof CountryCodes>;
